import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function NotificationEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function NotificationCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"Notification"} children={children} />
    );
}